import React, { useEffect, useState } from 'react';
import { /* useDispatch, */ useSelector } from 'react-redux';

import { /*  MyThunkDispatch, */ RootState } from 'store';
import useStoreTranslation from 'hooks/useStoreTranslation';
import useToast from 'hooks/useToast';
import BreakRulesForm from 'screens/components/BreakRulesForm';
import { extractErrorMessage } from 'utils/generic';
import { useParams } from 'react-router-dom';
import { getBreakRulesReason } from 'services/resellerTravel';
import { DataTravelReason } from 'models/travelReseller';

const BreakRulesFormContainer = () => {
  /*   const dispatch: MyThunkDispatch = useDispatch(); */
  const { /* company, */ isLoading, error } = useSelector((state: RootState) => state.companyBilling);
  const toast = useToast();
  const { t } = useStoreTranslation();
  const { breakRulesId } = useParams<{ breakRulesId?: string }>();
  const [breakRulesReasonSelected, setBreakRulesReasonSelected] = useState<DataTravelReason | undefined>();
  const [loading, setLoading] = useState<boolean>(false);

  useEffect(() => {
    if (error) toast.add({ type: 'danger', message: extractErrorMessage(error) || t('defaultError.default') });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [error]);

  useEffect(() => {
    console.log(breakRulesId);
    if (!breakRulesId) {
      setLoading(true);
      return;
    }

    getBreakRulesReasonId();
  }, []);
  const getBreakRulesReasonId = async () => {
    setLoading(false);
    try {
      const data = await getBreakRulesReason(breakRulesId);
      if (data) {
        setBreakRulesReasonSelected(data);
        setLoading(true);
      }
    } catch (error) {
      toast.add({
        type: 'danger',
        // @ts-ignore
        message: error.message,
      });
      setLoading(false);
    }
  };

  return <>{loading && <BreakRulesForm isLoading={isLoading} breakRulesReasonSelected={breakRulesReasonSelected} />}</>;
};

export default BreakRulesFormContainer;
